module.exports = __webpack_public_path__ + "img/cancel1.5fc22b37.svg";